module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"ja":{"total_reviews_count":"{0}個"}}')
  delete Component.options._Ctor
}
